import React from 'react';
import SimplizeLogo from '../../../components/SimplizeLogo';
import { DOCK_PILL_WIDTH, DOCK_PILL_HEIGHT, DOCK_BOTTOM_OFFSET } from '../config/modes';

export default function DockPill({ onClick, label = 'Hỏi Nebula', hint = 'Shift + /' }) {
    return (
        <button
            type="button"
            onClick={onClick}
            aria-label={label}
            className="dock-pill-animate fixed left-1/2 z-30 flex items-center gap-2 px-4 rounded-full bg-white/95 backdrop-blur border border-gray-200 shadow-lg hover:shadow-xl hover:bg-white transition-shadow"
            style={{
                bottom: DOCK_BOTTOM_OFFSET,
                width: DOCK_PILL_WIDTH,
                height: DOCK_PILL_HEIGHT,
            }}
        >
            <SimplizeLogo className="h-5 w-auto flex-shrink-0" iconOnly />
            <span className="flex-1 text-left text-sm text-gray-400 truncate">{label}</span>
            <span className="flex-shrink-0 text-[11px] text-gray-500 bg-gray-100 border border-gray-200 rounded px-1.5 py-0.5">
                {hint}
            </span>
        </button>
    );
}
